import api from '@/shared/api/api-client';

import type { ForgotPasswordGateway } from './forgot-password.gateway';

/**
 * Real implementation over the shared api client. The single place that knows
 * the endpoint (kept 1:1 with the original `ForgotPassword` page's
 * `api.post('/auth/forgot-password', { email })`). The client prefixes `/v1`,
 * and `/v1/auth/*` endpoints are CSRF-exempt; the response body is unused.
 */
export const httpForgotPasswordGateway: ForgotPasswordGateway = {
  requestPasswordReset: async (email) => {
    await api.post('/auth/forgot-password', { email });
  },
};
